import { BrandConfig, CustomClients, CustomClientsTitle } from '@thehubz/shared/branding';
import { TermsAndConditions } from '@thehubz/shared/model';
import { UserSession } from '../models';

export type EnvironmentKey = 'LOCAL' | 'DEV' | 'DEMO' | 'LIVE' | 'QA' | 'NEXT';

export type FileFormatKeys = 'main' | 'gen-thumbnail' | 'gen-preview' | 'gen-preview-xl' | 'pdf-preview' | 'gen-convert';

export type MainNavigationItem = 'Dashboard' | 'Collaboration' | 'Library' | 'Admin' | 'Wiki';

export interface ClientEnvironment {
  production: boolean;
  appVersion?: string;
  environment: EnvironmentKey;
  brandingKey: CustomClients;
  brandingTitle?: CustomClientsTitle;
  brandPortalUrl?: string;
  appTitle?: string;
  uploadStepperConf?: {
    buyoutRightSingleStepper: boolean;
  };
  apiBasePath: string;
  fileAccessUrl: string;
  s3Config: {
    bucket: string;
  };
  azureAD?: {
    clientId: string;
    tenantId: string;
    redirectUri: string;
  };
  startPage: string;
  /**
   * Whether to show the terms and conditions popup on certain actions
   */
  termsConditionsPopup?: {
    onRegistration?: boolean;
    onLogin?: boolean;
    onAssetDownload?: boolean;
    content: TermsAndConditions;
    logoSrc?: string;
    linkText?: string;
  };
  collectionGuideLink?: string;
  captchaApiKey?: string; // for AWS WAF captcha
  brandConfig?: BrandConfig;
  exportDownloads?: {
    fileName?: string;
    addTime?: boolean;
  };
  exportUserReportDownload?: {
    fileName?: string;
    addTime?: boolean;
  };
  exportMetadataDownloads?: {
    fileName?: string;
    addTime?: boolean;
  };
  feature?: {
    global?: {
      collaboration?: boolean;
      wiki?: boolean;
    };
    tagGroups?: boolean;
    admin?: {
      removeFromUsers?: boolean; // Enable the feature to remove groups from users
    };
  };
  isGuidedTourEnabled?: boolean;
  footerPages?: {
    showFooter?: boolean;
  };
  assetDownload?: {
    fileName?: string;
    collectionInitial?: string;
    excludeFormat?: FileFormatKeys[];
    sortFormatsBy?: 'size' | 'medium';
  };
  assetMetadata?: {
    domains?: {
      defaultAgency?: string; // company ID
      defaultClient?: string; // company ID
      defaultBrand?: string; // brand ID
    };
  };
  infoBanner?: {
    enabled?: boolean;
    logoSrc?: string;
    salutationFunction?: (userSession: UserSession) => string;
  };
  idleTimeout?: number;
  assetStatusIcon?: boolean;
  publicSharing?: {
    mode: 'select' | 'always';
    baseUrl: string;
    emailMandatory?: boolean;
  };
  hideMainNavigationMenus?: MainNavigationItem[];
}
